import { SagaIterator } from 'redux-saga';
import { takeEvery, takeLatest } from 'redux-saga/effects';
import { IWorkbookDetailInfo } from '../../../../ts/models/IWorkbookInfo';
import { Workbooks } from '../../../../content/resources/Workbooks';
import { DeleteContents, EditWorkbook, NewWorkbookForDatasource, SetContentPermissions, SetOwner, SetTabsWorkbook, SetTags, OpenWorkbookInDesktopDialog } from '../../../actions/AppActionTypes';
import { deleteContents } from '../content/DeleteContentsSaga';
import { setContentPermissions } from '../content/SetContentPermissionsSaga';
import { handleSetTags } from '../SetTagsSagas';
import { handleEditWorkbookAction } from './EditWorkbookSaga';
import { handleNewWorkbookForDatasourceAction } from './NewWorkbookForDatasourceSagas';
import { handleSetOwner } from './SetOwnerSagas';
import { setTabsWorkbookSaga } from './SetTabsWorkbookSaga';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';
import { handleOpenWorkbookInDesktop } from './OpenWorkbookInDesktopSaga';

export function fetchWorkbookById(workbookId: string): ng.IPromise<IWorkbookDetailInfo> {
  return Workbooks.getById(workbookId);
}

export function getExtractDraftId(workbookId: string): ng.IPromise<IResult> {
  return Workbooks.getExtractDraftId(workbookId);
}


export function* rootWorkbookSaga(): SagaIterator {
  yield takeEvery(SetOwner, handleSetOwner);
  yield takeEvery(SetTabsWorkbook, setTabsWorkbookSaga);
  yield takeLatest(SetTags, handleSetTags);
  yield takeEvery(DeleteContents, deleteContents);
  yield takeLatest(SetContentPermissions, setContentPermissions);
  yield takeEvery(EditWorkbook, handleEditWorkbookAction);
  yield takeEvery(OpenWorkbookInDesktopDialog, handleOpenWorkbookInDesktop);
  yield takeEvery(NewWorkbookForDatasource, handleNewWorkbookForDatasourceAction);
}
